import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum TABLE_COLUMNS_IDS {
  SCOPE = 'scope',
  PERIOD = 'period',
  STRIPE_PLAN_ID = 'stripePlanId',
  PRICE = 'price',
  ORDER_NUMBER = 'orderNumber',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = TABLE_COLUMNS_IDS.SCOPE;

function _getTableColumns(t: TFunction): IOrderFlexibleColumns[] {
  return [
    {
      id: TABLE_COLUMNS_IDS.SCOPE,
      label: t('common.scope'),
      key: TABLE_COLUMNS_IDS.SCOPE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.SCOPE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.PERIOD,
      label: t('common.period'),
      key: TABLE_COLUMNS_IDS.PERIOD,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.PERIOD,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.STRIPE_PLAN_ID,
      label: t('superAdminDashboard.stripePlanId'),
      key: TABLE_COLUMNS_IDS.STRIPE_PLAN_ID,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.STRIPE_PLAN_ID,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.PRICE,
      label: t('common.price'),
      key: TABLE_COLUMNS_IDS.PRICE,
      type: 'number',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.PRICE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ORDER_NUMBER,
      label: t('common.orderNumber'),
      key: TABLE_COLUMNS_IDS.ORDER_NUMBER,
      type: 'number',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ORDER_NUMBER,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIONS,
      key: TABLE_COLUMNS_IDS.ACTIONS,
      type: 'string',
      sortable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIONS,
      align: 'left',
      hided: false,
      isFixed: true,
      canHide: false,
    },
  ];
}

const getTableColumns = (t: TFunction) => _getTableColumns(t);

const hidedColumns: string[] = [];

export const getDefaultSettings = (t: TFunction) => ({
  columnsOrderIds: Object.keys(_getTableColumns(t)).filter(
    (columnId) => !hidedColumns.includes(columnId),
  ),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});

export default getTableColumns;
